<template>
  <!-- 验证 -->
  <div class="check">
    <van-dialog :value="checkInfo.showCheckModal" title="" :showConfirmButton="false">
      <div class="check-modal-conatiner">
        <img src="@/assets/image/check.png" alt="" />
        <div class="title">验证</div>
        <div v-if="checkInfo.showCheckModal" class="track" style="width:240px" :class="{active: status}">
          <span v-if="!status">请滑动完成验证</span>
          <span v-else style="color:#fff">验证通过</span>
          <div class="track-bg"></div>
          <div @touchstart="touchstart" @touchmove="touchmove" @touchend="touchend" class="track-htn">
            <i v-if="!status" style="fontSize:20px" class="el-icon-d-arrow-right"></i>
            <i v-else style="color:#7ac23c;fontSize:20px" class="el-icon-success"></i>
          </div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import {getValidation, validation} from '@/api'
export default {
  data() {
    return {
      status: false,
      id: this.$route.params.id
    }
  },
  computed: {
    video() {
      return this.$store.state.activePlay.video
    },
    checkInfo() {
      return this.$store.state.activePlay.checkInfo
    }
  },
  mounted() {
    this.checkHasCheck()
  },
  methods: {
    checkHasCheck() {
      getValidation({id: this.id, type: 1}).then(res => {
        if (res.code === 0 && res.data) {
          const validationBegin = res.data.validationBegin
          const validationEnd = res.data.validationEnd
          const isOpen = res.data.isOpen === 1
          const randomTime = Math.floor(
            Math.random() * (validationEnd * 60 - validationBegin * 60) + validationBegin * 60
          )
          this.$store.commit('setCheckInfo', {
            isOpen,
            randomTime
          })
        }
      })
    },
    touchstart(e) {
      if (this.status) {
        return false
      }
      const pWidth = 240
      const targetWidth = 60
      this.canMoveWidth = pWidth - targetWidth
      this.startX = e.changedTouches[0].clientX
    },
    touchmove(e) {
      if (this.status) {
        return false
      }
      const endX = e.changedTouches[0].clientX
      this.distance = endX - this.startX
      if (this.distance <= 0) {
        this.distance = 0
      }
      if (this.distance >= this.canMoveWidth) {
        this.distance = this.canMoveWidth
      }
      e.target.style.transform = 'translateX(' + this.distance + 'px)'
      const bg = this.$el.querySelector('.track-bg')
      bg.style.width = this.distance + 30 + 'px'
      e.preventDefault()
    },
    touchend(e) {
      if (this.distance !== this.canMoveWidth) {
        this.distance = 0
        e.target.style.transform = 'translateX(' + this.distance + 'px)'
        const bg = this.$el.querySelector('.track-bg')
        bg.style.width = '0px'
      } else {
        this.status = true
        this.check()
      }
    },
    check() {
      const params = {
        objectId: this.id,
        objectType: 1,
        sourceFor: 2,
        tagType: this.video.isLive ? 1 : 2
        // tagTime: Number(this.currentTime)
      }
      validation(params).then(res => {
        if (res.code === 0) {
          this.$Toast.success('验证成功')
        }
        this.$store.commit('setCheckInfo', {
          showCheckModal: false
        })
        this.status = false
        this.$parent.videoPauseOrPlayForCheck(true)
      })
    }
  }
}
</script>

<style scoped lang="scss">
.check-modal-conatiner {
  background-color: #fff;
  padding: 25px 10px;
  border-radius: 10px;
  text-align: center;
  img {
    width: 58px;
  }
  .title {
    font-weight: bold;
    font-size: 18px;
    padding: 20px 0;
  }
}

.track {
  position: relative;
  margin: 0 auto;
  //   width: 240px;
  height: 40px;
  background: #eaedf1;
  border-radius: 20px;
  color: rgba(192, 196, 204, 1);
  text-align: center;
  line-height: 40px;
  overflow: hidden;
  &.active {
    background: #7ac23c;
  }
  span {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    z-index: 2;
  }
  span::selection {
    background: none;
    color: none;
  }
  .track-htn {
    position: relative;
    z-index: 3;
    transition: translateX 0.1s;
    text-align: center;
    line-height: 40px;
    width: 60px;
    height: 40px;
    background: #ffffff;
    border: 1px solid #cfd0d2;
    border-radius: 20px;
    cursor: pointer;
    i {
      pointer-events: none;
      position: relative;
      left: 2px;
      top: 2px;
    }
  }
  .track-bg {
    z-index: 1;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 0;
    background: #7ac23c;
    text-align: center;
    color: #fff;
  }
}
</style>
